'use client';

import React, { useEffect } from 'react';
import { ConLogoAtom } from '@gandalf/babylon/atoms/logo';
import { extractCountryCode } from '@frodo/lib/utils/common/helper';
import { Link } from '@frodo/ui/tokens';
import { globalErrorTrans } from '@frodo/lib/utils/common/globalErrorTrans';
import { getPublicImagePath } from '@frodo/lib/utils/common/urlUtils';

export default function GlobalError(error: Error) {
  const countryCode = extractCountryCode(window.location.host);
  const countryTrans = globalErrorTrans[countryCode];

  useEffect(() => {
    if (!window.DD_RUM) return;

    window.DD_RUM.onReady(function () {
      window.DD_RUM.addError(error);
    });
  }, [error]);

  return (
    <html lang={countryCode}>
      <head>
        <title>contorion</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta httpEquiv="Cache-Control" content="no-cache" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta httpEquiv="x-dns-prefetch-control" content="on" />
        <meta name="robots" content="noindex, follow" />
        <meta name="theme-color" content="#333333" />
        <meta title="description" content="contorion error" />
        <meta title="author" content="contorion" />
        <link
          rel="apple-touch-icon"
          href={getPublicImagePath('favicon-apple-touch-icon_152x152.png')}
        />
        <link
          rel="icon"
          type="image/png"
          href={getPublicImagePath('favicon-32.png')}
          sizes="32x32"
        />
        <link rel="shortcut icon" href={getPublicImagePath('favicon-16.png')} />
        <style>
          {`
          body {
            margin: 0;
          }
          .header {
            height: 100px;
            background-color: #2c2c2c;
            display: flex;
            align-items: center;
          }
          .headerContainer {
            max-width: 945px;
            margin: 0 auto;
          }
          .logo {
            width: 180px;
            height: 32px;
          }
          .content {
            max-width: 700px;
            min-height: 550px;
            margin: 200px auto;
            text-align: center;
          }
          .errorCode {
            color: #09f;
            font-size: 60px;
            font-weight: bold;
          }
          .errorTitle {
            font-size: 30px;
            font-weight: bold;
          }
          .errorExplanation {
            text-align: left;
            font-size: 16px;
            font-weight: 600;
          }
          `}
        </style>
      </head>
      <body>
        <div className="header">
          <div className="headerContainer">
            <Link ariaLabel="Home" href="/">
              <div className="logo">
                <ConLogoAtom color="light" />
              </div>
            </Link>
          </div>
        </div>
        <div className="content">
          <span className="errorCode">500 Error</span>
          <h2 className="errorTitle">{countryTrans['exception']}</h2>
          <div className="errorExplanation">
            {countryTrans['exception.explanation']}
          </div>
        </div>
      </body>
    </html>
  );
}
